import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { PromotionAnalyticsData } from '@/modules/dashboard/type'
import { DataTableArrow } from '@/common/ui/table/data-table-arrow'
import { columns } from '../PromotionAnalyticsTable/constants'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'

interface PromotionAnalyticsListingProps {
	data: PromotionAnalyticsData[]
	isLoading?: boolean
	onSort?: (columnId: string, order: 'asc' | 'desc' | undefined) => void
	total: number
}

export default function PromotionAnalyticsListing({
	data,
	total,
	isLoading,
	onSort,
}: PromotionAnalyticsListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<div className="flex flex-col space-y-4">
					<Heading
						title="วิเคราะห์โปรโมชั่น"
						description="ข้อมูลการใช้งานและผลการดำเนินงานของโปรโมชั่น"
					/>
					<div className="flex items-center gap-2">
						<DataTableSearch placeHolder="ค้นหาชื่อโปรโมชั่น" />
						<DataTableResetFilter />
					</div>
				</div>
				<div className="flex flex-col items-end gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<Separator />
			<div className="space-y-4">
				<DataTableArrow
					columns={columns}
					data={data}
					total={total}
					isLoading={isLoading}
					onSort={onSort}
				/>
			</div>
		</div>
	)
}
